import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=2dc9627a&scoped=true&"
import script from "./ActionCard.vue?vue&type=script&lang=ts&"
export * from "./ActionCard.vue?vue&type=script&lang=ts&"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=2dc9627a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc9627a",
  null
  
)

export default component.exports